// src/context/CartContext.js
import React, { createContext, useContext } from 'react';

// Define the shape of the context value
const CartContext = createContext({
    cartItems: [], // Array of { productId, quantity, splitter }
    cartDetails: [], // Array of detailed product objects with quantity and splitter
    setCartDetails: (details) => {}, // NEW: Setter for direct cart manipulation
    isLoadingCart: false, // Loading state for fetching details
    totalCartItemsCount: 0, // Derived total quantity
    discountPercentage: 0, // State for discount percentage
    // Handlers
    toggleItemInCart: (productId, isSelected) => {},
    removeItemFromCart: (productId) => {},
    updateItemQuantity: (productId, quantityChange) => {},
    updateItemSplitter: (productId, splitterValue) => {}, // NEW: Handler for splitter
    addCustomProduct: (customProduct) => {}, // NEW: Handler for custom products (ProductId = NULL)
    updateCustomProduct: (customProductId, updatedFields) => {}, // NEW: Update custom product fields
    clearCart: () => {},
    setDiscountPercentage: (percentage) => {}, // Setter for discount
    getDisplayRetailPrice: (originalPrice) => 0,
    subTotalPrice: 0, // Exposing subTotalPrice from context
    totalAfterDiscount: 0, // Exposing totalAfterDiscount from context
    // Volume pricing functions
    toggleVolumePrice: (productId) => {},
    getVolumePrice: (retailPrice, productId) => 0,
    isVolumePricingActive: (productId) => false,
    getVolumePricingTier: (productId) => null,
    clientDatabaseName: null, // Client database name
});

// Custom hook to easily access the cart context
export const useCart = () => {
    const context = useContext(CartContext);
    if (context === undefined) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};

export default CartContext;